import styled from 'styled-components';

const EngagementWrapper = styled.section`
  padding: 100px 0;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);

  @media (max-width: 767px) {
    padding: 60px 0;
  }

  .section-header {
    text-align: center;
    margin-bottom: 60px;
  }

  h2 {
    font-size: 42px;
    font-weight: 300;
    color: #fff;
    letter-spacing: -0.025em;
    line-height: 1.2;
    margin-bottom: 20px;

    @media (max-width: 991px) {
      font-size: 36px;
    }
    @media (max-width: 575px) {
      font-size: 28px;
    }
  }

  .section-subtitle {
    font-size: 18px;
    color: rgba(255, 255, 255, 0.6);
    max-width: 650px;
    margin: 0 auto;
    line-height: 1.7;
    font-weight: 300;

    @media (max-width: 575px) {
      font-size: 16px;
    }
  }

  .steps-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 25px;
    margin-bottom: 60px;

    @media (max-width: 991px) {
      grid-template-columns: 1fr 1fr;
      gap: 20px;
    }
    @media (max-width: 575px) {
      grid-template-columns: 1fr;
    }
  }

  .step-card {
    padding: 30px 25px;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.08);
      border-color: rgba(241, 102, 0, 0.3);
      transform: translateY(-4px);
    }

    .step-number {
      font-size: 32px;
      font-weight: 200;
      color: #f16600;
      display: block;
      margin-bottom: 15px;
      font-variant-numeric: tabular-nums;
    }

    h3 {
      font-size: 18px;
      font-weight: 600;
      color: #fff;
      margin-bottom: 12px;
    }

    p {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.55);
      line-height: 1.7;
      margin: 0;
    }
  }

  .tiers-section {
    margin-bottom: 50px;
  }

  .tiers-title {
    text-align: center;
    font-size: 13px;
    font-weight: 700;
    color: #f16600;
    text-transform: uppercase;
    letter-spacing: 0.15em;
    margin-bottom: 30px;
  }

  .tiers-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 25px;

    @media (max-width: 767px) {
      grid-template-columns: 1fr;
      gap: 15px;
    }
  }

  .tier-card {
    padding: 30px 25px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    text-align: center;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(255, 255, 255, 0.06);
      border-color: rgba(241, 102, 0, 0.2);
    }

    h4 {
      font-size: 18px;
      font-weight: 600;
      color: #fff;
      margin-bottom: 12px;
    }

    p {
      font-size: 14px;
      color: rgba(255, 255, 255, 0.55);
      line-height: 1.6;
      margin-bottom: 15px;
    }

    .tier-duration {
      display: inline-block;
      font-size: 12px;
      font-weight: 600;
      color: #f16600;
      text-transform: uppercase;
      letter-spacing: 0.1em;
      padding: 6px 16px;
      background: rgba(241, 102, 0, 0.1);
      border-radius: 20px;
    }
  }

  .engagement-cta {
    text-align: center;

    button {
      display: inline-flex;
      align-items: center;
      gap: 10px;
      background: linear-gradient(135deg, #f16600 0%, #ff8534 100%);
      color: #fff;
      font-size: 16px;
      font-weight: 600;
      padding: 16px 35px;
      border-radius: 8px;
      border: none;
      cursor: pointer;
      transition: all 0.3s ease;
      box-shadow: 0 8px 25px rgba(241, 102, 0, 0.3);

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 35px rgba(241, 102, 0, 0.4);
      }

      &:active {
        transform: translateY(-1px);
      }
    }
  }
`;

export default EngagementWrapper;
